export default __webpack_public_path__ + "static/media/indira_college.59423ef9.png";